import { FC } from 'react';

import { Alert } from 'app/state/AlertsContext/Provider';

import AlertUI from './AlertUI';

// Local Typings
interface Props {
  alerts: Alert[];
}

// Component Definition
const Alerts: FC<Props> = props => (
  <>
    {props.alerts.map((alert, i) => (
      <AlertUI
        actions={alert.actions}
        // eslint-disable-next-line react/no-array-index-key
        key={`${i}-${alert.timestamp}`}
        message={alert.message}
        title={alert.title}
      />
    ))}
  </>
);

export default Alerts;
